import { getDataAll } from '../../utils/dataUtils';
import { SendData } from '../../utils/SendData';
import { updateDataAll, hardUpdateDataAll, updateInputNames, setData, fildsetInit } from './fieldsetData';

export function setupMutationObserver(managerInstance) {
  managerInstance.observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.querySelectorAll) {
            node.querySelectorAll('fieldset').forEach((fieldset) => {
             fildsetInit(fieldset);
            });
          }

          if (node.nodeType === 1 && node.matches('fieldset')) {
             fildsetInit(node);
          }
        });

        mutation.removedNodes.forEach((node) => {
          if (node.nodeType === 1 && node.matches('fieldset')) {
            updateDataAll(node);
          }
          if (node.querySelectorAll) {
            node.querySelectorAll('fieldset').forEach((fieldset) => {
              updateDataAll(fieldset);
            });
          }
        });
      }

      if (mutation.type === 'attributes') {
        const fieldset = mutation.target.closest('fieldset:not([disabled])');
        if (fieldset) {
          updateDataAll(fieldset);
        }
      }
    });
  });

  managerInstance.observer.observe(document.body, {
    childList: true,
    attributes: true,
    subtree: true,
    attributeFilter: ['value', 'name', 'checked', 'selected', 'disabled']
  });
}

export function updateAllFieldsets() {
  document.querySelectorAll('fieldset:not([disabled])').forEach((fieldset) => {
    updateDataAll(fieldset);
  });
}